module.exports = __webpack_public_path__ + "static/media/fj.49f9fa66.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/fj.svg
// module id = 646
// module chunks = 0